import { alpha, Box, Typography, useTheme } from '@mui/material'

const CustomNoResultsOverlay = () => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        textAlign: 'center',
        backgroundImage: `radial-gradient(circle, ${alpha(theme.palette.text.primary, 0.2)} 1px, transparent 1px)`, // ✅ actual gradient
        backgroundSize: '20px 20px', // adjust spacing as needed
        backgroundColor: () => 'background.defaultdim', // optional base background
      }}
    >
      <Typography sx={{ fontSize: 18, textAlign: 'center', width: '100%' }}>
        NO MATCHES FOUND FOR YOUR FILTERS.
      </Typography>
    </Box>
  )
}
export default CustomNoResultsOverlay
